module.exports = __webpack_public_path__ + "img/ios-badge.1324de6.png";